import React from "react";
import { Box } from "rebass/styled-components";

export default function Title3(props) {
  return (
    <Box variant="text.title3" {...props}>
      {props.children}
    </Box>
  );
}
